import script from "./PlacementSizeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PlacementSizeEditor.vue?vue&type=script&setup=true&lang=js"

import "./PlacementSizeEditor.vue?vue&type=style&index=0&id=e96c08a8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96c08a8"]])

export default __exports__